module.exports = __webpack_public_path__ + "static/media/RELAY12 1.f826b77a.png";